import {
  BulletListIcon,
  FeatureRequestIcon,
  RedirectIcon,
  SupportIcon,
  UserIcon,
} from "allIcons";
import { ListIconWrapper, MainButton, SecondaryHeading } from "commonUI";
import { t } from "i18next";

const ResourceModule = ({ icon, title, description, buttonText, link }) => {
  return (
    <div
      className="p-2-2 border-2 border-theme-card-bg flex gap-10 flex-col"
      style={{ width: "188px", borderTopLeftRadius: "5px", borderTopRightRadius: "5px" }}
    >
      <ListIconWrapper>{icon}</ListIconWrapper>
      <div className="w-full">
        <SecondaryHeading>{title}</SecondaryHeading>
        <p className="body-text text-11 m-0">{description}</p>
      </div>
      <a href={link} target="_blank" rel="noopener noreferrer">
        <MainButton buttonType="secondary" className="w-fit">
          <RedirectIcon fill="black" />
          {buttonText}
        </MainButton>
      </a>
    </div>
  );
};

export default function Resources() {
  return (
    <>
      <div className="bg-white gap-15 p-5 rounded-5">
        <SecondaryHeading>{t("dashboard.resources.title")}</SecondaryHeading>
        <p className="body-text mt-1-5 mb-0">
          {t("dashboard.resources.explainerText")}
        </p>
        <div className="mt-3 flex items-center gap-15 flex flex-wrap">
          <ResourceModule
            icon={<BulletListIcon />}
            title={t("dashboard.resources.whatsNew.title")}
            description={t("dashboard.resources.whatsNew.description")}
            buttonText={t("dashboard.resources.whatsNew.buttonText")}
            link={"https://wpsitelauncher.com/release-notes"}
          />
          <ResourceModule
            icon={<SupportIcon />}
            title={t("dashboard.resources.support.title")}
            description={t("dashboard.resources.support.description")}
            buttonText={t("dashboard.resources.support.buttonText")}
            link={"https://wpsitelauncher.com/support"}
          />
          <ResourceModule
            icon={<FeatureRequestIcon />}
            title={t("dashboard.resources.featureRequests.title")}
            description={t("dashboard.resources.featureRequests.description")}
            buttonText={t("dashboard.resources.featureRequests.buttonText")}
            link={"https://wpsitelauncher.com/contact"}
          />
          <ResourceModule
            icon={<UserIcon />}
            title={t("dashboard.resources.joinOurCommunity.title")}
            description={t("dashboard.resources.joinOurCommunity.description")}
            buttonText={t("dashboard.resources.joinOurCommunity.buttonText")}
            link={"https://www.facebook.com/groups/903970873522537"}
          />
        </div>
      </div>
    </>
  );
}
